﻿﻿﻿<div class="container-tab-lists">
    <branchhierarchy-menu (onReload)="onReload()" (newBranch)="onNewBranch()" (outputDownload)="downloadBranchHierarchy()"></branchhierarchy-menu>

    <h2>Branch Hierarchy</h2>
    <div style="display:flow-root; margin-bottom: 1rem">
        <div style="text-align:right; float:right">
            <h5>**Please notice that the "Branch" field cannot contain hyphens.**</h5>
            <h5>**A PBI must be created and assigned to anyone from DevOps Team for deploying new changes.**</h5>
        </div>
    </div>
    <branchhierarchy-list [list]="list" [listRef]="listRef" [listKey]="listKey" [listTimeZones]="listTimeZones" [newService]="newBranch" (onDelete)="onDelete($event)"></branchhierarchy-list>
</div> 